import ability from '../acl/ability';
import router from '@/router';

let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));

export function permission(perm) {
	return userInfo.god_mode || ability.can(perm);
}

export function permissionRedirect(perm) {
	if (!permission(perm)) {
		router.push('/pages/not-authorized');
	}
}
